import { useEffect, useRef } from "react";
import { processSteps } from "@/mocks/services";

export default function Process() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0");
            entry.target.classList.remove("opacity-0", "translate-y-8");
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = containerRef.current?.querySelectorAll("[data-animate]");
    if (items) {
      items.forEach((item, index) => {
        item.classList.add("opacity-0", "translate-y-8", "transition-all", "duration-700");
        (item as HTMLElement).style.transitionDelay = `${index * 150}ms`;
        observer.observe(item);
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="process" className="py-20 md:py-28 bg-dark-50">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block bg-brand-50 text-brand-700 px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-brand-200">
              Kako funkcionišemo
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-dark-900 mb-4">
              Od konsultacije do
              <br />
              <span className="text-brand-500">potpune zaštite</span>
            </h2>
            <p className="text-dark-400 text-lg max-w-2xl mx-auto">
              Jednostavan proces u 4 koraka — bez stresa, bez skrivenih troškova
            </p>
          </div>

          <div ref={containerRef} className="relative">
            <div className="hidden lg:block absolute top-12 left-0 right-0 h-0.5 bg-dark-200 z-0"></div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 relative z-10">
              {processSteps.map((step, index) => (
                <div
                  key={index}
                  data-animate=""
                  className="bg-white rounded-2xl border border-dark-100 p-6 md:p-8 text-center relative group hover:-translate-y-2 transition-all duration-300"
                >
                  <div className="w-16 h-16 flex items-center justify-center mx-auto bg-brand-50 rounded-full mb-6 group-hover:bg-brand-500 transition-all">
                    <i className={`${step.icon} text-2xl text-brand-500 group-hover:text-white transition-all`}></i>
                  </div>

                  <div className="absolute -top-3 -right-3 w-10 h-10 flex items-center justify-center bg-brand-500 text-white rounded-full text-sm font-bold shadow-lg">
                    {step.step}
                  </div>

                  <h3 className="text-lg font-bold text-dark-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-dark-400 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}